import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 0.5C30.7692 0.500228 39.4999 9.2308 39.5 20C39.4999 30.7692 30.7691 39.4998 20 39.5C9.23074 39.4999 0.500129 30.7692 0.5 20C0.500099 9.23072 9.23072 0.500099 20 0.5ZM20 26.2334C18.6841 26.2335 17.6436 27.2314 17.6436 28.5039C17.6439 29.7762 18.6843 30.7743 20 30.7744C21.3156 30.7742 22.3571 29.7761 22.3574 28.5039C22.3574 27.2314 21.3158 26.2336 20 26.2334ZM20.0146 9.22656C18.7134 9.22664 17.8879 10.0214 17.8877 11.3516C17.8877 11.4671 17.9023 11.6407 17.9023 11.7852L18.1338 21.793C18.1627 23.0221 18.7998 23.746 20 23.7461C21.2 23.7459 21.8365 23.0221 21.8799 21.793L22.0967 11.7852C22.1111 11.6407 22.1113 11.4671 22.1113 11.3516C22.1112 10.0216 21.3012 9.2268 20.0146 9.22656Z",
		fill: "#EF4444"
	})
});
export default SvgError;
